  import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Row,
  Select,
  Space,
  Table,
  Tooltip
} from 'antd';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Archive } from '../../Images/archive.svg';
import { ReactComponent as Archiveicon } from '../../Images/Archiveicon.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as ColumnListIcon } from '../../Images/ColumnList.svg';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';

  function BulkOrderList() {
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);

    const dataSource = [
      {
        key: '1',
        srNo: '1',
        partyName: 'Psp Projects Limited',
        orderDate: '18 Oct 2024',
        incidentNo: '123456',
        remarks: 'Remark here',
      },
      {
        key: '2',
        srNo: '2',
        partyName: 'Psp Projects Limited',
        orderDate: '18 Oct 2024',
        incidentNo: '123456',
        remarks: 'Remark here',
      },
      {
        key: '3',
        srNo: '3',
        partyName: 'Psp Projects Limited',
        orderDate: '18 Oct 2024',
        incidentNo: '123456',
        remarks: 'Remark here',
      },
      {
        key: '4',
        srNo: '4',
        partyName: 'Psp Projects Limited',
        orderDate: '18 Oct 2024',
        incidentNo: '123456',
        remarks: 'Remark here',
      },
      {
        key: '5',
        srNo: '5',
        partyName: 'Psp Projects Limited',
        orderDate: '18 Oct 2024',
        incidentNo: '123456',
        remarks: 'Remark here',
      },
      {
        key: '6',
        srNo: '6',
        partyName: 'Psp Projects Limited',
        orderDate: '18 Oct 2024',
        incidentNo: '123456',
        remarks: 'Remark here',
      },
      {
        key: '7',
        srNo: '7',
        partyName: 'Psp Projects Limited',
        orderDate: '18 Oct 2024',
        incidentNo: '123456',
        remarks: 'Remark here',
      },
    ];

    const columns = [
      {
        title: 'Sr. No.',
        dataIndex: 'srNo',
        sorter: (a, b) => a.srNo - b.srNo,
      },
      {
        title: 'Party Name',
        dataIndex: 'partyName',
        sorter: (a, b) => a.partyName.localeCompare(b.partyName),
      },
      {
        title: 'Order Date',
        dataIndex: 'orderDate',
        sorter: (a, b) => new Date(a.orderDate) - new Date(b.orderDate),
      },
      {
        title: 'Incident No',
        dataIndex: 'incidentNo',
        sorter: (a, b) => a.incidentNo - b.incidentNo,
      },
      {
        title: 'Remarks',
        dataIndex: 'remarks',
      },
      {
        title: 'Action',
        dataIndex: 'action',
        render: (_, record) => (
          <Space size="middle">
            <Link  onClick={showDrawer}>
              <Tooltip title='Edit'>
                <EditIcon />
              </Tooltip>
            </Link>
            <Link>
              <Tooltip title='Archive'>
                <Archive />
              </Tooltip>
            </Link>
          </Space>
        ),
      },
    ];

    const onSearchChange = e => {
      setSearchText(e.target.value);
    };

    const rowSelection = {
      selectedRowKeys,
      onChange: selectedKeys => {
        setSelectedRowKeys(selectedKeys);
      },
    };

    const showDrawer = () => {
      setIsDrawerVisible(true);
    };

    const closeDrawer = () => {
      setIsDrawerVisible(false);
    };

    const onFinish = values => {
     
      closeDrawer();
    };
    return (
      <>
        <Row className="pagenamerow" justify="space-between" align="middle">
          <Col>

            <h2>Bulk Order List</h2>
            <div className="bredcrumbwrp">
              <Link to="/dashboard" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                  items={[
                      { title: <Link to="/dashboard">Home</Link> },
                      { title: 'Bulk Order List' }
                  ]}
              />
            </div>
          </Col>
          <Col>
            <Space size="small">
              <Input
                placeholder="Search"
                  className='searchbox'
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={onSearchChange}
                style={{ width: '100%' }}
              />
              <Link className='iconlink'>
                <Tooltip title="Filter">
                  <FilterIcon />
                </Tooltip>
              </Link>
              <Link>
                <Tooltip title='Create Bulk Order'>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={showDrawer}
                  >
                    Create Bulk Order
                  </Button>
                </Tooltip>
              </Link>
              <Link to="/archive-bulk-order-list" className='iconlink'>
                <Tooltip title="Archive">
                  <Archiveicon />
                </Tooltip>
              </Link>
              <Link className='iconlink'>
                <Tooltip title="Column List">
                  <ColumnListIcon />
                </Tooltip>
              </Link>
            </Space>
          </Col>

        </Row>
        <Table
          rowSelection={rowSelection}
          columns={columns}
          dataSource={dataSource}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          className="mt-5"
          scroll={{
            x: 880,
          }}
        />
        <Drawer
          title="Create Bulk Order"
          width={400}
          onClose={closeDrawer}
          visible={isDrawerVisible}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form layout="vertical" onFinish={onFinish}>

            <Form.Item
              name="partyName"
              label="Party"
              rules={[
                { required: true, message: 'Please select party' },
              ]}
            >
              <Select placeholder="Select Customer" />
            </Form.Item>
            <Form.Item
              name="orderDate"
              label="Order Date"
              rules={[
                { required: true, message: "Please select order date" },
              ]}
            >
              <DatePicker style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item
              name="incidentNo"
              label="Incident No"
              rules={[
                { required: true, message: 'Please enter the incident number' },
              ]}
            >
              <Input placeholder="Enter Incident No" />
            </Form.Item>
            <Form.Item
              name="remarks"
              label="Remarks"
              rules={[{ required: true, message: 'Please enter remarks' }]}
            >
              <Input.TextArea placeholder="Enter Remarks" />
            </Form.Item>
            <div className="flex justify-end">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
              >
                Create Bulk Order
              </Button>
            </div>
          </Form>
        </Drawer>

      </>
    );
  }

  export default BulkOrderList;
